import styled from 'styled-components'

export const CategoryEditorContainer = styled.div`
    .default-row {
        display: 'flex';
        flex-direction: 'column';
        width: '100%';
        margin-left: '10px';
    }
    .field-row-margin {
        input,
        label {
            margin-left: 0.6em;
        }

        .Select-control {
            margin-top: 4px;
        }
    }

    .description {
        display: flex;
        flex-direction: column;
    }

    .control-label,
    .description-text {
        margin-left: 0.6em;
    }
    .description-text {
        color: #172033;
        padding: 16px 0px 16px 2px;
    }

    .unmonitored-postscript {
        font-style: oblique;
        font-weight: 600;
    }

    .quali-button-text-bundle {
        padding: 16px;
        display: grid;
        grid-template-columns: 172px 1fr;
        gap: 16px;
        .quali-default-text {
            display: flex;
            align-items: center;
        }

        .quali-default-button {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid var(--gray-300);
            background: var(--gray-0);
            border-radius: 3px;
            height: 32px;
            /* align-self: center; */
            &.editing {
                cursor: pointer;
            }
            &.editing:active {
                background: var(--blue-500);
                color: var(--gray-0);
            }
        }
    }
`
